const clinicManagement = {
  id: 2,
  slug: "clinic-management-system",

  title: "Clinic Management System",
  shortTitle: "ClinicMS",

  description:
    "A Flutter-based clinic management platform that digitizes patient registration, appointments, queue management, prescriptions, billing, and medical records using Firebase.",

  category: "Healthcare",
  type: "Client Project",
  status: "Completed",
  year: "2026",

  timeline: "5 Months",

  developedBy: "Horyzen Technologies",

  technologies: [
    "Flutter",
    "Dart",
    "Firebase",
    "Cloud Firestore",
    "Firebase Authentication",
    "Cloud Functions",
    "Provider"
  ],

  image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&w=1600&q=80",

  liveUrl: "",
  githubUrl: ""
};

export default clinicManagement;